import gql from 'graphql-tag'

export const getExecutivesForReports = gql`
  query executivesForReports{
    executivesForReports: executives_for_reports
  }
`
